import { render, staticRenderFns } from "./ingredientList.vue?vue&type=template&id=81e32a24"
import script from "./ingredientList.vue?vue&type=script&lang=js"
export * from "./ingredientList.vue?vue&type=script&lang=js"
import style0 from "./glossary.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports